import Dropdown from './Dropdown/Dropdown';
import { NavLink } from 'react-router-dom';
import { IMenuItem } from './types';
import visibleOnRelease from '../../config/visibleOnRelease';
import { useContext } from 'react';
import { SeasonContext } from '../../context/SeasonContext';
import { Season } from '../../config/globalVariables';
import { useTranslation } from 'react-i18next';

interface IProps {
  isMobileMenuVisible?: boolean;
  toggleMobileMenuVisibility?: () => void;
}

const MenuItems = (props: IProps) => {
  const { t } = useTranslation('components');
  const { season } = useContext(SeasonContext);
  const toggleMobileMenuVisibility = () => {
    if (props.isMobileMenuVisible) {
      props.toggleMobileMenuVisibility?.();
    }
  };

  const menuItems: IMenuItem[] = [
    {
      id: 1,
      title: t('navigation.buy'),
      submenu: [
        {
          title: t('navigation.accommodation.accommodation'),
          url: '/activities/accommodation',
        },
        {
          title: t('navigation.tickets.ski_park'),
          url: '/activities/tickets',
        },
        // {
        //   title: t('navigation.tickets.rental_ski'),
        //   url: '/activities/rental-ski',
        // },
        // {
        //   title: t('navigation.tickets.ski_school'),
        //   url: '/rental/rental-ski',
        // },
        {
          title: t('navigation.tickets.therms_park'),
          url: '/activities/therms-tickets',
        },
        { title: t('navigation.parking'), 
          url: '/activities/parking' 
        },
        {
          title: t('navigation.tickets.rental_bike'),
          url: '/activities/rental-bike',
        },
        {
          title: t('navigation.rental_ski_school'),
          url: '/rental/rental-ski',
        },
        {
          title: t('navigation.autumn_promotion'),
          url: '/promo?promoCode=SEPTEMBER',
        },
      ].filter((menu) => {
        let pass = true;

        if (menu.url === '/activities/rental-bike') {
          pass = visibleOnRelease.rentalBike;
        }

        if (Season.Winter === season) {
          if (menu.url === '/activities/tickets') {
            menu.title = t('navigation.tickets.ski_park');
          }
        } else {
          if (menu.url === '/activities/tickets') {
            menu.title = t('navigation.tickets.ski_park_summer');
            pass = visibleOnRelease.summerLifts;
          }
        }

        if (menu.url === '/activities/rental-ski') {
          pass = Season.Winter === season;
          pass = visibleOnRelease.rentalAndSchool;
        }

        if (menu.url === '/activities/ski-school') {
          pass = Season.Winter === season;
          pass = visibleOnRelease.rentalAndSchool;
        }
        if (menu.url === '/rental') {
          pass = Season.Winter === season;
        }
        return pass;
      }),
    },
    {
      id: 2,
      title: t('navigation.information'),
      submenu: [
        {
          title: t('navigation.accommodation.rooms'),
          url: '/accommodation',
        },
        {
          title:
            season === Season.Winter
              ? t('navigation.ski_park')
              : t('navigation.bike_park'),
          url: '/ski-park',
        },
        { title: t('navigation.therms_park'), url: '/therms-park' },
        { title: t('navigation.rental_ski_school'), url: '/rental' },
        {
          title: t('navigation.about_region'),
          url: '/about-region',
        },
      ],
    },
    {
      id: 3,
      title: t('navigation.price_list'),
      url: '/price-list',
    },
    {
      id: 4,
      title: t('navigation.map'),
      url: '/map',
    },
    {
      id: 5,
      title: t('navigation.webcams'),
      url: '/webcams',
      submenu: [
        {
          title: t('navigation.ski_park_webcams'),
          url: '/ski-park/webcams',
        },
        {
          title: t('navigation.therms_park_webcams'),
          url: '/therms-park/webcams',
        },
      ].filter((menu) => {
        let pass = true;

        if (menu.url === '/ski-park/webcams') {
          pass = Season.Winter === season;
        }
        return pass;
      }),
    },
  ];

  return (
    <>
      {menuItems.map((item: IMenuItem, index: number) => {
        if (item.submenu) {
          return (
            item.submenu.length > 0 && (
              <li key={index} className="berg-components-menu-item">
                <Dropdown
                  item={item}
                  onItemClick={toggleMobileMenuVisibility}
                />
              </li>
            )
          );
        } else
          return (
            <li key={index} className="berg-components-menu-item">
              <NavLink onClick={toggleMobileMenuVisibility} to={item.url ?? ''}>
                <span>{item.title}</span>
              </NavLink>
              <span
                aria-hidden
                className="berg-components-menu-item-bold-template"
              >
                {item.title}
              </span>
            </li>
          );
      })}
    </>
  );
};

export default MenuItems;
